var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/history") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/history",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_history_24px",
    transform: "translate(0.000000, 2.000000)",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7142857,0 C8.03428571,0 3.42857143,4.60571429 3.42857143,10.2857143 L0,10.2857143 L4.44571429,14.7314286 L4.52571429,14.8914286 L9.14285714,10.2857143 L5.71428571,10.2857143 C5.71428571,5.86285714 9.29142857,2.28571429 13.7142857,2.28571429 C18.1371429,2.28571429 21.7142857,5.86285714 21.7142857,10.2857143 C21.7142857,14.7085714 18.1371429,18.2857143 13.7142857,18.2857143 C11.5085714,18.2857143 9.50857143,17.3828571 8.06857143,15.9314286 L6.44571429,17.5542857 C8.30857143,19.4171429 10.8685714,20.5714286 13.7142857,20.5714286 C19.3942857,20.5714286 24,15.9657143 24,10.2857143 C24,4.60571429 19.3942857,0 13.7142857,0 Z M12.5714286,5.71428571 L12.5714286,11.4285714 L17.4628571,14.3314286 L18.2857143,12.9485714 L14.2857143,10.5714286 L14.2857143,5.71428571 L12.5714286,5.71428571 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.32f64a8caaa9ca06b377ed59cde45ece.svg";
export { ForwardRef as ReactComponent };